<template>
  <TWModal
    :show="show"
    :title="$t('functional.logout')"
    :loading="loading"
    @close="handleClose"
    data-test="logout-modal"
  >
    <template v-slot:content>
      <p>
        {{ $t('functional.logoutMessage') }}
      </p>
    </template>

    <template v-slot:controls>
      <BaseButton
        @click.native="handleClose"
        variant="invisible"
        data-test="button-cancel-logout"
        data-ec="logout_modal"
        data-et="cancel_button"
      >
        {{ $t('functional.cancel') }}
      </BaseButton>

      <BaseButton
        @click.native="handleLogout"
        data-test="button-confirm-logout"
        data-ec="logout_modal"
        data-et="logout_button"
      >
        {{ $t('functional.logout') }}
      </BaseButton>
    </template>
  </TWModal>
</template>

<script setup>
// @ts-check
import { ref } from 'vue';
import { useActions } from 'vuex-composition-helpers/dist';
import { destroy as destroyProductFruits } from '@/utils/external/productFruits';

import BaseButton from '@/components/library/buttons/BaseButton.vue';
import TWModal from '@/components/tailwind/Modal.vue';

defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['close']);

const loading = ref(false);

const { logout } = useActions({ logout: 'auth/LOGOUT' });

async function handleLogout() {
  loading.value = true;

  try {
    // passing false to preserveRouteWhenLoggingBackIn
    await logout(false);
    emit('close');
  } finally {
    loading.value = false;
    destroyProductFruits();
  }
}

function handleClose() {
  emit('close');
}
</script>
